var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inFavorites)?_c('i',{staticClass:"icon-favourites-full"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }